import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PillBox from "../../assets/icons/medicineList/PillBox";
import UserIcon from "../../assets/icons/medicineList/UserIcon";
import Upload from "../../assets/icons/medicineList/Upload";
import Select from "../Select";
import { MdEdit } from "react-icons/md";
import ModalStructure from "../ModalStructure";

import Refresh from "../../assets/icons/Refresh";
import {
  deleteSupply,
  deleteSupplyFile,
  deleteSupplyImage,
  updateSupplyProps,
  updateSupplyQuantity,
  uploadSupplieFile,
  uploadSupplieImage,
} from "../../services/medicines";
import { TiArrowSortedUp } from "react-icons/ti";
import { TiArrowSortedDown } from "react-icons/ti";
import TableInput from "../TableInput";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";

const header = [
  "Nombre científico",
  "Nombre del cliente",
  "Foto del medicamento",
  "PDF",
  "Presentación",
  "Cantidad",
  "Unidad y medida",
  "",
];
const bodyCols = [
  "sName",
  "cName",
  "supplyImage",
  "supplyFile",
  "presentation",
  "quantity",
  "unit",
  "",
];

const MedicineListTable = ({
  _data,
  uamSelectOptions,
  presSelectOptions,
  updateSortedProp,
}) => {
  const [data, setData] = useState(_data);
  const [sortType, setSortType] = useState("default");
  const [sortedColumn, setSortedColumn] = useState(-1);
  const [file, setFile] = useState(null);
  const [selectedSupplyIndexPDF, setSelectedSupplyIndexPDF] = useState(null); // Index de la fila seleccionada para manejar modales
  const [selectedSupplyIndexImage, setSelectedSupplyIndexImage] =
    useState(null);
  const [updatingSupply, setUpdatingSupply] = useState(false);
  const [deletingSupply, setDeletingSupply] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);
  const [newImgFile, setNewImgFile] = useState(null);
  const [quantityToIncrementIndex, setQuantityToIncrementIndex] =
    useState(null);
  const [quantityToIncrement, setQuantityToIncrement] = useState(0);
  const [operation, setOperation] = useState("");
  const [showQuantityModalConfirm, setShowQuantityModalConfirm] =
    useState(false);
  //===================para custom inputs=========================
  // Nuevo estado para el input activo
  const [activeInput, setActiveInput] = useState(null);

  // Función para manejar el clic en la celda
  const handleCellClick = (rowPos, col) => {
    setActiveInput((prev) => {
      // Si la celda clickeada es la misma que la activa, no cambiar el estado
      if (prev && prev.rowPos === rowPos && prev.col === col) {
        return prev; // No hace nada, mantiene la celda activa
      }

      // Si es una celda diferente, activa la nueva celda
      return { rowPos, col };
    });
  };

  const updateSomeValue = (newValue, rowPos, prop) => {
    let temp = [...data];
    temp[rowPos][prop] = newValue;
    setData(temp);
  };

  //==============================================================
  useEffect(() => {
    setData(_data);
  }, [_data]);

  //================Seleccionar archivo pdf o imagen=======================

  const handleFileChange = (e, type) => {
    const selectedFile = e.target.files[0]; // Obtén el primer archivo seleccionado
    if (selectedFile) {
      // Verifica si el archivo es un PDF
      if (selectedFile.type.startsWith("image/") && type == "supplyImage") {
        setNewImgFile(selectedFile);
      } else if (
        selectedFile.type === "application/pdf" &&
        type == "supplyFile"
      ) {
        setFile(selectedFile);
      } else {
        Notification({
          title: "Operación inválida",
          text: `Inserte un archivo válido`,
          type: "Error",
        });
      }
    }
  };

  //=====================actualizar pdf o imagen (refactorizar)=========================
  const handleSumbitFile = (index, type) => {
    const uploadFile = async (index, type) => {
      try {
        setUpdatingSupply(true);
        //subir imagen o pdf ==========
        let fp = {};
        if (type == "supplyImage") {
          fp.file = newImgFile;
          fp.alt = "imagen medicina";
        } else fp.file = file;
        //==============================
        let newTypeObj = {};
        const response =
          type == "supplyImage"
            ? await uploadSupplieImage(fp)
            : await uploadSupplieFile(fp);
        newTypeObj = response;

        //eliminar imagen o pdf anterior
        if (type == "supplyImage" && data[index].supplyImage?.id)
          await deleteSupplyImage(data[index].supplyImage.id);
        else if (type == "supplyImage" && data[index].supplyFile?.id)
          await deleteSupplyFile(data[index].supplyFile.id);

        //actualizar data
        let props =
          type == "supplyImage"
            ? { supplyImage: newTypeObj.id }
            : { supplyFile: newTypeObj.id };
        IS_LOCAL_ENV && console.log("id de la medicina: ", data[index].id);
        const response2 = await updateSupplyProps(data[index].id, props);
        IS_LOCAL_ENV && console.log("se actualizo la imagen o el pdf");
        Notification({
          title: "Operación completada",
          text: `Se completó la carga`,
          type: "Success",
        });
        let temp = [...data];
        temp[index] = response2.doc;
        setData(temp);
        setUpdatingSupply(false);
      } catch (err) {
        setUpdatingSupply(false);
        IS_LOCAL_ENV && console.error(err);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
      }
    };
    uploadFile(index, type);
  };

  //====================== add or substract quantity =========================
  const submitEditQuantity = (rowPos, operation, qt) => {
    const quantity =
      operation == "add" ? Math.abs(parseFloat(qt)) : -Math.abs(parseFloat(qt));

    const updateQuantity = async (id, quantity) => {
      try {
        setUpdatingSupply(true);
        const response = await updateSupplyQuantity(id, quantity);
        let temp = [...data];
        //evaluar resultado de custom endpoint
        if (response.warning) {
          temp[rowPos] = response.supply;
          Notification({
            title: "Operación inválida",
            text: `${response.warning}`,
            type: "Error",
          });
        } else {
          temp[rowPos] = response;
          Notification({
            title: "Operación completada",
            text: `Se actualizó la cantidad`,
            type: "Success",
          });
        }
        setData(temp);
        setQuantityToIncrement(0);
        setUpdatingSupply(false);
        setQuantityToIncrementIndex(null);
        setShowQuantityModalConfirm(false);
        setOperation("");
      } catch (err) {
        setUpdatingSupply(false);
        IS_LOCAL_ENV && console.error(err);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
      }
    };
    updateQuantity(data[rowPos].id, quantity);
  };
  //================= sort funcs ============================

  const toggleSortedType = () => {
    if (sortType === "default" || sortType === "sorted") {
      setSortType("reversed");
      updateSortedProp(`-${bodyCols[sortedColumn]}`);
    } else {
      setSortType("sorted");
      updateSortedProp(bodyCols[sortedColumn]);
    }
  };

  const onCLickSortBy = (i) => {
    if (i === sortedColumn) {
      // Si se hace clic en la misma columna, cambiar el tipo de ordenamiento
      toggleSortedType();
    } else {
      // Si se hace clic en una columna diferente, establecer la nueva columna y ordenar
      setSortedColumn(i);
      updateSortedProp(bodyCols[i]);
      setSortType("sorted");
    }
  };

  //============================actualizar data(general)=============================

  const onClickUpdateSupply = (index) => {
    const uploadData = async (index) => {
      try {
        setUpdatingSupply(true);
        let props = {
          cName: data[index].cName,
          sName: data[index].sName,
          presentation: data[index].presentation,
          quantity: data[index].quantity,
          unit: data[index].unit,
        };
        if (data[index].supplyFile) {
          props.supplyFile = data[index].supplyFile.id;
        }
        if (data[index].supplyImage) {
          props.supplyImage = data[index].supplyImage.id;
        }
        await updateSupplyProps(data[index].id, props);
        Notification({
          title: "Operación completada",
          text: `Medicina actualizada exitosamente`,
          type: "Success",
        });
        setSelectedSupplyIndexImage(null);
        setSelectedSupplyIndexPDF(null);
        setUpdatingSupply(false);
      } catch (err) {
        setUpdatingSupply(false);
        IS_LOCAL_ENV && console.error(err);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
      }
    };
    uploadData(index);
  };

  //================================eliminar medicina=========================
  const onClickDeleteSupply = (index) => {
    const deleteData = async (index) => {
      try {
        setDeletingSupply(true);
        await deleteSupply(
          data[index].id,
          data[index].supplyImage?.id,
          data[index].supplyFile?.id
        );
        Notification({
          title: "Operación completada",
          text: `Se eliminó la medicina`,
          type: "Success",
        });
        setData(data.filter((item, i) => i !== index));
        setDeletingSupply(false);
        setSelectedDeleteIndex(null);
      } catch (err) {
        setDeletingSupply(false);
        IS_LOCAL_ENV && console.error(err);
        setSelectedDeleteIndex(null);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
      }
    };
    deleteData(index);
  };

  return (
    <>
      <Table className="overflow-hidden">
        <TableHead
          sx={{ display: "table-header-group", width: "100%" }}
          className="bg-dark-green font-white font-bold"
        >
          <TableRow sx={{ border: 0 }}>
            {header.map((columnTitle, i) => (
              <TableCell key={i} align={i > 0 ? "right" : ""}>
                <div className="justify-between items-center flex flex-row text-nowrap">
                  <span className="font-poppins font-bold text-white">
                    {columnTitle}
                  </span>
                  {![
                    "Foto del medicamento",
                    "PDF",
                    "Presentación",
                    "Unidad y medida",
                    "",
                  ].includes(columnTitle) && (
                    <span
                      className={`hover:bg-accent-green hover:opacity-90 p-1 mx-1 rounded-[50%] transition-colors ${
                        sortedColumn === i
                          ? "bg-white text-dark-green"
                          : "text-white"
                      }`}
                      onClick={() => onCLickSortBy(i)}
                    >
                      {sortedColumn === i && sortType === "reversed" ? (
                        <TiArrowSortedDown className="w-[25px] h-[25px]" />
                      ) : (
                        <TiArrowSortedUp className="w-[25px] h-[25px]" />
                      )}
                    </span>
                  )}
                </div>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((obj, i) => (
            <TableRow
              key={i}
              className={`${
                i % 2 === 0 ? "bg-white" : "bg-light-green"
              } border-y-[2px] border-accent-green`}
            >
              {bodyCols.map((col, j) => (
                <TableCell key={j} align={j > 0 ? "right" : ""}>
                  <div className="flex flex-row items-center">
                    {col === "supplyImage" ? (
                      <div className="flex flex-row items-center w-[20px] h-[20px]">
                        <img
                          src={
                            obj[col]
                              ? `${process.env.REACT_APP_SERVER}${obj[col].url}`
                              : ""
                          }
                          className="w-full h-full rounded-[50%]"
                        />
                        <span
                          className="ml-2 text-nowrap hover:text-blue-700 hover:underline font-poppins hover:cursor-pointer"
                          onClick={() => {
                            if (obj[col]) {
                              setSelectedSupplyIndexImage(i); // Abre el modal con la imagen correcta
                            }
                          }}
                        >
                          ver imagen
                        </span>
                      </div>
                    ) : col === "presentation" ? (
                      <Select
                        options={presSelectOptions}
                        value={obj[col]}
                        setValue={(e) =>
                          updateSomeValue(e.target.value, i, "presentation")
                        }
                        isTableSelect={true}
                        initialValue={parseInt(obj[col])}
                      />
                    ) : col === "unit" ? (
                      <Select
                        options={uamSelectOptions}
                        value={obj[col]}
                        setValue={(e) =>
                          updateSomeValue(e.target.value, i, "unit")
                        }
                        isTableSelect={true}
                        initialValue={parseInt(obj[col])}
                      />
                    ) : col === "supplyFile" ? (
                      <>
                        {obj[col] ? (
                          <>
                            <a
                              href={`${process.env.REACT_APP_SERVER}${obj[col].url}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-nowrap hover:text-blue-700 hover:underline font-poppins"
                            >
                              Descargar PDF
                            </a>
                            {/* &nbsp;
                          <PiLineVerticalBold className="text-dark-green w-[15px] h-[25px]" /> */}
                          </>
                        ) : (
                          <>
                            <span className="font-poppins text-nowrap">
                              Adjuntar PDF
                            </span>
                          </>
                        )}
                        <button
                          className="p-1 rounded-full hover:bg-gray-300"
                          onClick={() => setSelectedSupplyIndexPDF(i)}
                        >
                          <Upload />
                        </button>
                      </>
                    ) : col == "" ? (
                      <div className="flex flex-row items-center gap-x-2">
                        <button
                          className={` w-fit text-sm  rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
                            updatingSupply
                              ? "bg-default-gray cursor-not-allowed"
                              : "bg-dark-green hover:bg-accent-green"
                          } `}
                          onClick={(e) => {
                            onClickUpdateSupply(i);
                          }}
                          disabled={updatingSupply}
                        >
                          <div className="flex flex-row items-center gap-x-1 px-4">
                            <span className="text-nowrap">Actualizar</span>
                            <Refresh />
                          </div>
                        </button>

                        {/* <button
                          className={` w-fit text-sm  rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
                            updatingSupply
                              ? "bg-default-gray cursor-not-allowed"
                              : "bg-red-600 hover:bg-red-400"
                          } `}
                          onClick={(e) => {
                            setSelectedDeleteIndex(i);
                          }}
                          disabled={updatingSupply}
                        >
                          <div className="flex flex-row items-center gap-x-1 px-4">
                            <span className="text-nowrap">Eliminar</span>
                          </div>
                        </button> */}
                      </div>
                    ) : ["cName", "sName"].includes(col) ? (
                      <span
                        onClick={() => handleCellClick(i, col)}
                        className="cursor-pointer flex flex-row items-center font-poppins gap-x-1"
                      >
                        {col === "sName" && <PillBox />}
                        {col === "cName" && <UserIcon />}
                        {activeInput?.rowPos === i &&
                        activeInput.col === col ? (
                          <TableInput
                            rowPos={i}
                            col={col}
                            updValue={updateSomeValue}
                            value={obj[col]}
                            props={{ type: "text" }}
                            //w="w-[40px]"
                          />
                        ) : (
                          <span className="w-fit hover:bg-simple-gray p-[2px] rounded-[4px] hover:cursor-pointer">
                            {obj[col]}
                          </span>
                        )}
                      </span>
                    ) : (
                      col == "quantity" && (
                        <span
                          className={`font-poppins flex flex-row items-center gap-x-1`}
                        >
                          {obj[col]}
                          <button
                            className="hover:bg-simple-gray text-accent-green rounded-full p-1 "
                            onClick={() => setQuantityToIncrementIndex(i)}
                          >
                            <MdEdit />
                          </button>
                        </span>
                      )
                    )}
                  </div>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>

        {/* Modal de eliminar medicina*/}
        {selectedDeleteIndex !== null && (
          <ModalStructure
            handleCloseModal={() => setSelectedDeleteIndex(null)}
            customMaxW={"max-w-[400px]"}
          >
            <div className="font-poppins flex flex-col items-center">
              <h3 className="text-lg font-bold px-4">
                ¿Estás seguro de que quieres eliminar esta medicina?
              </h3>
              <button
                className={` w-fit  text-base m-4 mr-0 rounded-full py-2 px-4 text-white  transition-all duration-100 font-bold font-poppins ${
                  updatingSupply
                    ? "bg-default-gray cursor-not-allowed"
                    : "bg-red-600 hover:bg-red-400"
                } `}
                onClick={(e) => {
                  onClickDeleteSupply(selectedDeleteIndex);
                }}
                disabled={updatingSupply}
              >
                <div className="flex flex-row items-center gap-x-1 px-4">
                  <span className="text-nowrap">Eliminar</span>
                </div>
              </button>
            </div>
          </ModalStructure>
        )}
        {/*Modal para subir imagen */}
        {selectedSupplyIndexImage !== null && (
          <ModalStructure
            handleCloseModal={() => setSelectedSupplyIndexImage(null)}
            customMaxW={"max-w-[400px]"}
          >
            <div>
              <img
                src={`${process.env.REACT_APP_SERVER}${data[selectedSupplyIndexImage].supplyImage.url}`}
                alt={data[selectedSupplyIndexImage].supplyImage.alt}
                className="w-[300px]"
              />
            </div>
            <h3 className="font-poppins font-bold text-dark-green text-wrap text-base mt-4">
              Cargar nueva imagen
            </h3>
            <input
              className="font-poppins rounded-full text-nowrap border-accent-green border-[1px] px-4 flex flex-col w-fit text-sm"
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, "supplyImage")}
            />
            {newImgFile && (
              <button
                className={`w-fit text-base flex justify-center rounded-full py-2 px-4 text-white my-2 ${
                  updatingSupply
                    ? "bg-default-gray cursor-not-allowed"
                    : "bg-light-purple-600 hover:bg-dark-purple"
                } transition-all duration-100 font-bold font-poppins`}
                onClick={() => {
                  handleSumbitFile(selectedSupplyIndexImage, "supplyImage");
                }}
              >
                {updatingSupply ? (
                  "Subiendo archivo..."
                ) : (
                  <>
                    <span className="text-nowrap">Subir archivo</span>
                  </>
                )}
              </button>
            )}
          </ModalStructure>
        )}

        {/* Modal de subir PDF */}
        {selectedSupplyIndexPDF !== null && (
          <ModalStructure
            handleCloseModal={() => setSelectedSupplyIndexPDF(null)}
            customMaxW="max-w-[400px]"
          >
            <div className="flex flex-col items-center justify-center gap-y-4 mx-8">
              <h3 className="font-poppins font-bold text-dark-green text-wrap text-base">
                Selecciona un archivo para subir
              </h3>
              <input
                className="font-poppins rounded-full text-nowrap border-accent-green border-[1px] mx-4 flex flex-col w-fit text-sm"
                type="file"
                accept="application/pdf"
                onChange={(e) => handleFileChange(e, "supplyFile")}
              />
              {file && (
                <button
                  className={`w-fit text-base flex justify-center rounded-full py-2 px-4 text-white ${
                    updatingSupply
                      ? "bg-default-gray cursor-not-allowed"
                      : "bg-light-purple-600 hover:bg-dark-purple"
                  } transition-all duration-100 font-bold font-poppins`}
                  onClick={() => {
                    handleSumbitFile(selectedSupplyIndexPDF, "supplyFile");
                  }}
                >
                  {updatingSupply ? (
                    "Subiendo archivo..."
                  ) : (
                    <>
                      <span className="text-nowrap">Subir archivo</span>
                    </>
                  )}
                </button>
              )}
            </div>
          </ModalStructure>
        )}
        {/* Modal para actualizar la cantidad de medicinas */}
        {quantityToIncrementIndex !== null && (
          <ModalStructure
            handleCloseModal={() => setQuantityToIncrementIndex(null)}
            customMaxW={"max-w-[400px]"}
          >
            <div className="flex flex-col items-center justify-center gap-y-4 my-2 font-poppins">
              <h3 className="font-poppins font-bold text-dark-green text-wrap text-lg">
                Agregar o Restar
              </h3>
              <input
                className="font-poppins rounded-full text-nowrap border-accent-green border-[1px] flex flex-col w-[100px] text-sm"
                type="number"
                value={quantityToIncrement}
                min="0"
                onChange={(e) => {
                  setQuantityToIncrement(e.target.value);
                  IS_LOCAL_ENV && console.log("valor: ", e.target.value);
                }}
              />
              <div className="flex flex-row items-center gap-x-2">
                <button
                  className="bg-dark-green text-base m-4 rounded-full py-2 px-4 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins"
                  onClick={() => {
                    setOperation("add");
                    setShowQuantityModalConfirm(true);
                  }}
                >
                  <span className="flex flex-row items-center gap-x-2">
                    <span>Agregar</span>
                  </span>
                </button>
                <button
                  className="bg-dark-green text-base m-4 rounded-full py-2 px-4 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins"
                  onClick={() => {
                    setOperation("substract");
                    setShowQuantityModalConfirm(true);
                  }}
                >
                  <span className="flex flex-row items-center gap-x-2">
                    <span>Restar</span>
                  </span>
                </button>
              </div>
              {showQuantityModalConfirm && (
                <ModalStructure
                  handleCloseModal={() => setShowQuantityModalConfirm(false)}
                  customMaxW={"max-w-[250px]"}
                >
                  <h3 className="font-poppins font-bold text-dark-green text-wrap text-lg">
                    Está seguro de esta acción?
                  </h3>
                  <button
                    className="bg-dark-green text-base m-4 rounded-full py-2 px-4 text-white hover:bg-accent-green transition-all duration-100 font-bold font-poppins"
                    onClick={() =>
                      submitEditQuantity(
                        quantityToIncrementIndex,
                        operation,
                        quantityToIncrement
                      )
                    }
                  >
                    <span className="flex flex-row items-center gap-x-2">
                      <span>Sí</span>
                    </span>
                  </button>
                </ModalStructure>
              )}
            </div>
          </ModalStructure>
        )}
      </Table>
    </>
  );
};

export default MedicineListTable;
